var _DISPLAY_AMOUNT_HEIGH;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var DISPLAY_AMOUNT_NONE = 'none';
export var DISPLAY_AMOUNT_SMALL = 'short';
export var DISPLAY_AMOUNT_MEDIUM = 'intermediate';
export var DISPLAY_AMOUNT_LARGE = 'tall';
export var DISPLAY_AMOUNT_TYPES = [DISPLAY_AMOUNT_LARGE, DISPLAY_AMOUNT_MEDIUM, DISPLAY_AMOUNT_SMALL, DISPLAY_AMOUNT_NONE];
/**
 * These values should match the ones defined in readMore.scss
 * $small-height: 75px;
 * $medium-height: 150px;
 * $large-height: 225px;
 */

var DISPLAY_AMOUNT_HEIGHT_NONE = 0;
var DISPLAY_AMOUNT_HEIGHT_SMALL = 75;
var DISPLAY_AMOUNT_HEIGHT_MEDIUM = 150;
var DISPLAY_AMOUNT_HEIGHT_LARGE = 225;
export var DISPLAY_AMOUNT_HEIGHT_MAP = (_DISPLAY_AMOUNT_HEIGH = {}, _defineProperty(_DISPLAY_AMOUNT_HEIGH, DISPLAY_AMOUNT_NONE, DISPLAY_AMOUNT_HEIGHT_NONE), _defineProperty(_DISPLAY_AMOUNT_HEIGH, DISPLAY_AMOUNT_SMALL, DISPLAY_AMOUNT_HEIGHT_SMALL), _defineProperty(_DISPLAY_AMOUNT_HEIGH, DISPLAY_AMOUNT_MEDIUM, DISPLAY_AMOUNT_HEIGHT_MEDIUM), _defineProperty(_DISPLAY_AMOUNT_HEIGH, DISPLAY_AMOUNT_LARGE, DISPLAY_AMOUNT_HEIGHT_LARGE), _DISPLAY_AMOUNT_HEIGH);
export var TOGGLE_LOCATION_TOP = 'top';
export var TOGGLE_LOCATION_BOTTOM = 'bottom';
export var TOGGLE_LOCATION_TYPES = [TOGGLE_LOCATION_TOP, TOGGLE_LOCATION_BOTTOM];